import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/.pruned/json/apps/web-app/src/app/(anon)/auth/signin/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/.pruned/json/node_modules/next-translate/lib/esm/AppDirI18nProvider.js");
